import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["coreTheme", "onClick"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/FileInput/IconTrashButton.js",
    _this = this;

import React from 'react';
import styled from 'styled-components';
import { Trash as TrashIcon } from '@dls/assets/icons';
import { withClearInteraction } from '../../helpers/styled';
import { withTheme } from '../../core/ThemeProvider';

var IconTrashButton = function IconTrashButton(_ref) {
  var coreTheme = _ref.coreTheme,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    onClick: onClick,
    enableInteraction: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(TrashIcon, {
    size: 22,
    color: coreTheme.cl_sec_d1,
    "data-testid": "trash-icon",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 7
    }
  }));
};

export var IconContainer = withTheme(withClearInteraction(styled.div.withConfig({
  displayName: "IconTrashButton__IconContainer",
  componentId: "sc-176pojw-0"
})(["cursor:pointer;position:relative;display:inline-block;padding:", "px;"], function (p) {
  return p.coreTheme.space_1;
}), 8));
export default withTheme(IconTrashButton);